<template>
  <div class="home sms-templates">
    <div class="filter-wrapper filter-wrapper-tab">
      <div class="link-wrapper">
        <router-link :to="{ name: 'SmsTemplate'}">
          Templates
        </router-link>
        <router-link :to="{ name: 'SmsLogs'}">
          Logs
        </router-link>
      </div>
      <div class="link-filter-wrapper">
        <div>
          <call-checked-closed-opened
            v-model="dataFilterOpenedClosed"
            :name-tab="['Active', 'Inactive']" />
          <v-select
            v-if="!computedIsOperator"
            v-model="dataSelectTeamsValue"
            :options="dataSelectOptionsTeam"
            label="name"
            :components="{Deselect: dataComponentDeselect}"
            placeholder="All Teams"
            :class="['call-select', 'sms-templates__teams-filter teams-filter', dataSelectTeamsValue ? 'call-select--value' : null]"
            @input="$_ajax({ reset: true })">
            <template #open-indicator="{ attributes }">
              <span v-bind="attributes">
                <font-awesome-icon :icon="dataIconDown" />
              </span>
            </template>
            <template
              slot="option"
              slot-scope="option">
              <div class="d-center">
                <font-awesome-icon
                  v-if="!option.is_active"
                  class="tabel-icon--red"
                  style="font-size: 10px;"
                  :icon="dataIconLock" />
                {{ option.name }}
              </div>
            </template>
          </v-select>
        </div>

        <div>
          <call-pagination
            page-calc
            :obj-pagination="dataObjPagination"
            @on-pagination="$_ajax" />
          <call-button
            :icon="dataAddIcon"
            type="success"
            @click="clickShowAddTemplate()">
            Add Template
          </call-button>
        </div>
      </div>
    </div>
    <div class="table-wrapper">
      <b-table
        :show-empty="isLoaded"
        striped
        hover
        no-local-sorting
        :fields="dataMixinSmsFields"
        :items="dataSmsList"
        sort-by="created_at"
        :sort-desc="true"
        @sort-changed="onSortTabel"
        @row-hovered="onHover"
        @row-clicked="(value) => onActions(value, 'view')"
        @row-unhovered="onUnHover">
        <template #empty>
          <EmptyTable />
        </template>
        <template #cell(isBlocked)="data">
          <font-awesome-icon
            v-if="!data.item.is_active"
            class="tabel-icon--red"
            :icon="dataIconBan" />
          <font-awesome-icon
            v-else
            class="tabel-icon--green"
            :icon="dataIconCheck" />
        </template>
        <template #cell(name)="data">
          <call-tooltip
            placement="bottom"
            :content="data.item.body">
            <span>{{ data.item.name }}</span>
          </call-tooltip>
        </template>
        <template #cell(teams)="data">
          {{ data.item.teams | joinName }}
        </template>
        <template #cell(team_projects)="data">
          {{ getAllTableProjects(data.item.team_projects) | joinName }}
        </template>
        <template #cell(created_at)="data">
          {{ data.item.created_at | dateFilter }}
        </template>
        <template #cell(updated_at)="data">
          {{ data.item.updated_at | dateFilter }}
        </template>

        <template #cell(actions)="data">
          <call-table-sms-template-actions
            v-show="data.item.actions"
            :blocked="data.item.is_active"
            @on-action="(value) => onActions(data.item, value)" />
        </template>
        <template #cell(outcoming_cancelled_calls_count)="data">
          <span class="danger"> {{ data.item.outcoming_cancelled_calls_count || 0 }} </span>
        </template>
      </b-table>
    </div>
    <call-modal-add-sms-template
      v-model="dataShowAddTemplateSms"
      @on-update="() => $_ajax()" />
    <call-modal-update-sms-template
      v-model="dataShowUpdateTemplateSms"
      :template-id="dataOptionTemplateId"
      @on-update="() => $_ajax()" />
    <call-sms-active-deactivate
      v-model="dataShowActionConfirmSms"
      :obj-event="dataOptionObjEvent"
      @on-update="() => $_ajax()" />
  </div>
</template>

<script>
import { BTable } from 'bootstrap-vue';
import { SMS_TEMPLATE_GET_ALL, TEAMS_GET_ALL } from '../../../store/types/actions.types';
import helper, { tabelCell } from '../../../service/helper';
import CallPagination from '@/components/desktop/CallPagination';
import CallButton from '@/components/common/CallButton';
import { faBan, faCheck, faPlus, faChevronDown, faTimes, faPowerOff } from '@fortawesome/pro-regular-svg-icons';
import smsTable from '@/mixins/table/smsTable';
import CallModalAddSmsTemplate from '@/components/common/modals/CallAddSmsTemplate';
import CallTableSmsTemplateActions from '@/components/desktop/CallTableSmsTemplateActions';
import CallModalUpdateSmsTemplate from '@/components/common/modals/CallUpdateSmsTemplate';
import CallSmsActiveDeactivate from '@/components/common/modals/CallSmsActiveDeactivate';
import { mapGetters } from 'vuex';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import CallCheckedClosedOpened from '../../../components/common/CallCheckedClosedOpened';

export default {
  name: 'PageSms',
  components: {
    CallSmsActiveDeactivate,
    CallModalUpdateSmsTemplate,
    CallTableSmsTemplateActions,
    CallModalAddSmsTemplate,
    CallButton,
    CallPagination,
    BTable,
    CallCheckedClosedOpened
  },
  mixins: [smsTable],
  data () {
    return {
      isLoaded: false,
      dataIconLock: faPowerOff,
      dataAddIcon: faPlus,
      dataIconCheck: faCheck,
      dataIconBan: faBan,
      dataIconDown: faChevronDown,
      dataShowAddTemplateSms: false,
      dataShowUpdateTemplateSms: false,
      dataShowActionConfirmSms: false,
      dataOptionTemplateId: null,
      dataOptionObjEvent: {},
      dataObjPagination: {},
      dataSmsList: [],
      dataDesc: true,
      dataOrderBy: 'created_at',
      dataSelectTeamsValue: null,
      dataSelectOptionsTeam: [],
      dataComponentDeselect: {
        render: createElement => createElement(FontAwesomeIcon, {
          props: {
            icon: faTimes
          }
        })
      },
      dataFilterOpenedClosed: 'opened'
    };
  },

  computed: {
    ...mapGetters({
      computedIsOperator: 'auth/isOperator'
    }),
    computedDataFilterIsActive () {
      if (this.dataFilterOpenedClosed === 'closed') {
        return false;
      }
      if (this.dataFilterOpenedClosed === 'opened') {
        return true;
      }
      return undefined;
    }
  },
  watch: {
    dataFilterOpenedClosed (v) {
      this.$_ajax({ reset: true });
    }
  },
  async created () {
    this.$_ajax = ((options = {}) => {
      let _page = 0;
      let _limit = tabelCell();

      const { currentRoute: { name: pageName } = {} } = this.$router;

      const _filterKey = `_filter${pageName}`;

      if (!helper.isEmpty(this.$route.query, _filterKey)) {
        try {
          options = helper.clearObject(JSON.parse(this.$route.query[_filterKey]));

          const _arrFilter = [
            'desc',
            'orderBy',
            'limit',
            'page',
            'teamId',
            'is_active'
          ];

          for (const _key of _arrFilter) {
            if (!helper.isEmpty(options, _key)) {
              switch (_key) {
                case 'desc':
                  this.dataDesc = options[_key];
                  break;
                case 'orderBy':
                  this.dataOrderBy = options[_key];
                  break;
                case 'limit':
                  _limit = options[_key];
                  break;
                case 'page':
                  _page = options[_key];
                  break;
                case 'teamId':
                  this.dataSelectTeamsValue = options[_key];
                  break;
                case 'is_active':
                  this.dataFilterOpenedClosed = options[_key];
                  break;
              }
            }
          }
        } catch (e) {
          console.log('Error query params');
        }
      }

      return async ({
        teamId = this.dataSelectTeamsValue,
        desc = this.dataDesc,
        orderBy = this.dataOrderBy,
        limit = null,
        page = null,
        reset = false
      } = options) => {
        this.$store.dispatch('loading/startLoading');

        try {
          if (!helper.isEmpty(page) && page !== _page) {
            _page = page;
          }

          if (!helper.isEmpty(limit) && limit !== _limit) {
            _limit = limit;
          }

          if (reset) {
            _page = 0;
          }

          const { payload: { list = [] }, misc: { paging = {} } = {} } = await this.$store.dispatch(`sms/${SMS_TEMPLATE_GET_ALL}`, {
            params: {
              desc,
              order_by: orderBy,
              limit: _limit,
              page: _page,
              team_ids: [teamId?.id],
              is_active: this.computedDataFilterIsActive
            }
          });
          this.dataObjPagination = paging;
          this.dataSmsList = list.map((item) => {
            item.actions = false;
            return item;
          });

          this.$router.replace({
            ...this.$router.currentRoute,
            query: {
              [_filterKey]: JSON.stringify(helper.clearObject({
                desc,
                orderBy,
                limit: _limit,
                page: _page,
                teamId,
                is_active: this.dataFilterOpenedClosed
              }))
            }
          }).catch(() => {});

          options = {};
          this.isLoaded = true;
        } finally {
          this.$store.dispatch('loading/stopLoading');
        }
      };
    })();

    this.$store.dispatch('loading/startLoading');

    try {
      const [{ payload: { list: listTeam = [] } }] = await Promise.all([
        this.$store.dispatch(`team/${TEAMS_GET_ALL}`, {
          params: {
            short: true
          }
        }),
        this.$_ajax()
      ]);
      this.dataSelectOptionsTeam = listTeam.sort((a, b) => b.is_active - a.is_active);
    } finally {
      this.$store.dispatch('loading/stopLoading');
    }
  },
  methods: {
    getAllTableProjects (data) {
      return (data || []).flatMap(item => item.projects);
    },

    onSortTabel ({ sortBy, sortDesc }) {
      this.dataDesc = sortDesc;
      this.dataOrderBy = sortBy;
      this.$_ajax();
    },
    clickShowAddTemplate () {
      this.dataShowAddTemplateSms = true;
    },
    async  onActions ({ id: templateId, is_active, name = '' }, action) {
      switch (action) {
        case 'update':
          this.dataOptionTemplateId = templateId;
          this.dataShowUpdateTemplateSms = true;
          break;
        case 'blocked':
          this.dataOptionObjEvent = {
            templateId,
            is_active
          };
          this.dataShowActionConfirmSms = true;
          break;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
  .sms-templates {
    &__teams-filter {
      min-width: 160px;
      ::v-deep .vs__dropdown-menu {
        overflow-x: hidden;
      }
    }
  }
</style>
